import {
  ExternalIntegration,
  LinkedInIntegration,
  XIntegration,
  FacebookIntegration,
  InstagramIntegration,
} from 'api/clients/ExternalIntegrationsClient'
import Styles from './PostPreview.module.scss'
import InstagramStyles from './InstagramPreview.module.scss'

import { MediaObject } from 'types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { InstagramPreview } from 'components/Previews/InstagramPreview/InstagramPreview'
import AddImage from 'almanac-ui/icons/16/AddImage'
import { Pressable } from '@react-aria/interactions'
import { LinkedinPreview } from 'components/Previews/LinkedinPreview/LinkedinPreview'
import { FacebookPreview } from 'components/Previews/FacebookPreview/FacebookPreview'
import { XPreview } from 'components/Previews/XPreview/XPreview'
interface PostPreviewProps {
  channel?: ChannelType
  content: string
  mediaObjects?: MediaObject[]
  integration?: ExternalIntegration
  loading?: boolean
  openFileUploadPrompt: () => void
  hideConnectButton?: boolean
}

const renderPreview = ({
  channel,
  content,
  mediaObjects,
  integration,
  loading,
  openFileUploadPrompt,
  hideConnectButton,
}: PostPreviewProps) => {
  switch (channel) {
    case 'linkedin_posts':
    case 'linkedin_post' as ChannelType:
      return (
        <LinkedinPreview
          loading={loading}
          integration={integration as LinkedInIntegration}
          content={content}
          mediaObjects={mediaObjects}
          hideConnectButton={hideConnectButton}
        />
      )
    case 'instagram_posts':
    case 'instagram_post' as ChannelType:
      return (
        <InstagramPreview
          loading={loading}
          integration={integration as InstagramIntegration}
          content={content}
          emptyStateContent={
            <Pressable onPress={openFileUploadPrompt}>
              <div className={InstagramStyles.imageContainer}>
                <div className={InstagramStyles.imagePlaceholder}>
                  <div className={InstagramStyles.imagePlaceholderIcon}>
                    <AddImage size={42} />
                  </div>
                  <span className="placeholderText">Add Media</span>
                </div>
              </div>
            </Pressable>
          }
          mediaObjects={mediaObjects}
          hideConnectButton={hideConnectButton}
        />
      )
    case 'tweets':
      return (
        <XPreview
          loading={loading}
          integration={integration as XIntegration}
          content={content}
          mediaObjects={mediaObjects}
          hideConnectButton={hideConnectButton}
        />
      )
    case 'facebook_post':
      return (
        <FacebookPreview
          loading={loading}
          integration={integration as FacebookIntegration}
          content={content}
          mediaObjects={mediaObjects}
          hideConnectButton={hideConnectButton}
        />
      )
    default:
      return null
  }
}

export const PostPreview = ({
  channel,
  content,
  mediaObjects,
  integration,
  loading,
  openFileUploadPrompt,
  hideConnectButton,
}: PostPreviewProps) => {
  return (
    <div className={Styles.container} data-testid="post-preview">
      {renderPreview({
        channel,
        content,
        mediaObjects,
        integration,
        loading,
        openFileUploadPrompt,
        hideConnectButton,
      })}
    </div>
  )
}
